import React, { useState, useEffect, useRef  } from "react";
import { IconButton} from '@mui/material';
import Swal from "sweetalert2";
import { Delete, Edit } from '@mui/icons-material';
import "../../styles/MBABatch.css";
import FeesDetailsTable from "../Dashboard/Tables/FeesDetailsTable"; // Import your new table component
import NISMCertificationsTable from "../Dashboard/Tables/NISMCertificationsTable";
import DYPCollegeFeesTable from "../Dashboard/Tables/DYPCollegeFeesTable";
import FinxlCertificationsTable from "../Dashboard/Tables/FinxlCertificationsTable";
import PresentationsTable from "../Dashboard/Tables/PresentationsTable";
import {getMBABatchList} from '../../services/getAllApi';
import {saveMBABatchList} from '../../services/getAllApi';
import { deleteMBABatchList } from "../../services/getAdminApi"; // adjust the path as per your file structure



const MBABatch = () => {
  const [activeTable, setActiveTable] = useState(""); // Track which table is active

  const [students, setStudents] = useState([
    {
      id: 1,
      studentId: "",
      name: "",
      mobile: "",
      email: "",
      registrationDate: "",
      course: "",
      courseDuration: "",
      mode: "",
      counsellor: "",
      dySem: "",
      comments: "",
      uniform: "",
      applicationFees: "",
      totalfeesPaid: "",
    }
  ]);

   // 1️⃣ Resizable Table Logic
   const [colWidths, setColWidths] = useState({
    srNo: 50,
    studentId: 90,
    name: 200, // Resizable
    mobile: 92,
    email: 200, // Resizable
    registrationDate: 80,
    course: 130,
    courseDuration: 130,
    mode: 100,
    counsellor: 150, // Resizable
    dySem: 100,
    comments: 200, // Resizable
    uniform: 100,
    applicationFees: 120,
    totalfeesPaid: 100,
    actions: 100,
  });

  const resizingColumn = useRef(null);

  const handleMouseDown = (e, column) => {
    resizingColumn.current = { column, startX: e.clientX, startWidth: colWidths[column] };
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e) => {
    if (!resizingColumn.current) return;
    const { column, startX, startWidth } = resizingColumn.current;
    const newWidth = Math.max(50, startWidth + (e.clientX - startX)); // Min width 50px
    setColWidths((prev) => ({ ...prev, [column]: newWidth }));
  };

  const handleMouseUp = () => {
    resizingColumn.current = null;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };



  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const data = await getMBABatchList(); // ✅ use the Axios-based method
        const sortedData = data.sort((a, b) => a.studentId.localeCompare(b.studentId));
        setStudents(sortedData);
      } catch (error) {
        console.error("Error fetching MBA batch list:", error);
      }
    };
  
    fetchStudents();
  }, []);
  


  // Function to add a new row
  const handleAddRow = () => {
    const newStudent = {
      id: students.length + 1,
      studentId: "",
      name: "",
      mobile: "",
      email: "",
      registrationDate: "",
      course: "",
      courseDuration: "",
      mode: "",
      counsellor: "",
      dySem: "",
      comments: "",
      uniform: "",
      applicationFees: "",
      totalfeesPaid: "",

      // isNew: true,
    };
    setStudents([...students, newStudent]);
  };

  // Function to edit cell values
  const handleEdit = (index, field, value) => {
    setStudents(prevStudents => {
      const updatedStudents = [...prevStudents];
      updatedStudents[index] = { ...updatedStudents[index], [field]: value };
      return updatedStudents;
    });
  };

  const [isSaving, setIsSaving] = useState(false); // Track saving state
  const [lastSavedData, setLastSavedData] = useState([]);


  const handleSave = async () => {
    if (isSaving || students.length === 0) return;
  
    const isDuplicateSave = JSON.stringify(students) === JSON.stringify(lastSavedData);
    if (isDuplicateSave) {
      Swal.fire("Info", "No changes detected!", "info");
      return;
    }
  
    setIsSaving(true);
  
    try {
      const uniqueStudents = [...new Map(students.map(student => [student.studentId, student])).values()];

  
      const response = await saveMBABatchList(uniqueStudents);
  
      Swal.fire("Success", "Data saved successfully!", "success");
      setLastSavedData(uniqueStudents); // Update last saved data
    } catch (error) {
      console.error("Error saving data:", error);
      Swal.fire("Error", error.response?.data?.message || "Something went wrong!", "error");
    } finally {
      setIsSaving(false);
    }
  };
  

  // Function to delete a row
  const handleDelete = (index, studentId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Call the API to delete the student from the backend
          const deletedStudent = await deleteMBABatchList(studentId);

          // If deletion is successful, update the UI
          if (deletedStudent) {
            setStudents((prev) => prev.filter((_, i) => i !== index)); // Remove from state
            Swal.fire('Deleted!', 'The student has been removed.', 'success');
          }
        } catch (error) {
          Swal.fire('Error!', 'Failed to delete the student.', 'error');
        }
      }
    });
  };
  
  


  return (
    <div>
      <div className="mba-heading-div">
        <p>MBA Students Data</p>
      </div>
      <div className="table-btns">
        {activeTable === "" && (
          <>
            <button onClick={handleAddRow} className="add-row-btn">
              <i className="bx bx-plus"></i>
              <p className="button-add">Add Row</p>
            </button>
            <button onClick={handleSave} disabled={isSaving} className="save-btn">
              <p className="button-save">{isSaving ? "Saving..." : "Save"} Data</p>
            </button>
          </>
        )}
        <button onClick={() => setActiveTable("")} className="Click-btn"><p className="button-fees"> MBA Students List</p></button>
        <button onClick={() => setActiveTable("fees")} className="Click-btn"><p className="button-fees"> Fees Details</p></button>
        <button onClick={() => setActiveTable("dypfeestable")} className="Click-btn"><p className="button-DYPfees"> DYP College Fees Details</p></button>
        <button onClick={() => setActiveTable("nism")} className="Click-btn"><p className="button-nism"> NISM Certifications</p></button>
        <button onClick={() => setActiveTable("finxlcert")} className="Click-btn"><p className="button-finxl"> Finxl Certifications</p></button>
        <button onClick={() => setActiveTable("presentations")} className="Click-btn"><p className="button-presentation">Presentations Details</p></button>
      </div>

      {activeTable === "fees" && (
        <>

          <FeesDetailsTable
            students={students}
            isActive={activeTable === "fees"}
            handleSave={() => console.log("Save Clicked")}
            handleAddRow={() => console.log("Add Row Clicked")}
            isSaving={isSaving}
          />
        </>
      )}
      {activeTable === "dypfeestable" && (
        <>

          <DYPCollegeFeesTable
            students={students}
            isActive={activeTable === "dypfeestable"}
            handleSave={() => console.log("Save Clicked")}
            handleAddRow={() => console.log("Add Row Clicked")}
            isSaving={isSaving}
          />
        </>
      )}
      {activeTable === "nism" && (
        <>

          <NISMCertificationsTable
            students={students}
            isActive={activeTable === "nism"}
            handleSave={() => console.log("Save Clicked")}
            handleAddRow={() => console.log("Add Row Clicked")}
            isSaving={isSaving}
          />
        </>
      )}
      {activeTable === "finxlcert" && (
        <>

          <FinxlCertificationsTable
            students={students}
            isActive={activeTable === "finxlcert"}
            handleSave={() => console.log("Save Clicked")}
            handleAddRow={() => console.log("Add Row Clicked")}
            isSaving={isSaving}
          />
        </>
      )}
      {activeTable === "presentations" && (
        <>

          <PresentationsTable
            students={students}
            isActive={activeTable === "presentations"}
            handleSave={() => console.log("Save Clicked")}
            handleAddRow={() => console.log("Add Row Clicked")}
            isSaving={isSaving}
          />
        </>
      )}

      <div style={{ display: activeTable ? "none" : "table" }}>
        <div className="table-container-MBA-Students-list1">
        <table>
      <thead>
        <tr>
          {Object.keys(colWidths).map((key) => (
            <th key={key} style={{ width: colWidths[key], position: "relative" }}>
            {key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()} 
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                  bottom: 0,
                  width: "2px",
                  cursor: "col-resize",
                  background: "#d5e1ff85",
                }}
                onMouseDown={(e) => handleMouseDown(e, key)}
              />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {students.map((student, index) => (
          <tr key={student.id}>
            <td>{index + 1}</td>

            {/* Editable Cells */}
            {Object.keys(student).map((key) =>
              key !== "id" ? (
                <td key={key} style={{ width: colWidths[key], padding: "5px" }}>
                  {key === "mode" || key === "dySem" ? (
                    <select
                      value={student[key]}
                      onChange={(e) => handleEdit(index, key, e.target.value)}
                      style={{ width: "100%" }}
                    >
                      <option value="">Select</option>
                      {key === "mode" ? (
                        <>
                          <option value="Online">Online</option>
                          <option value="Offline">Offline</option>
                          <option value="Hybrid">Hybrid</option>
                        </>
                      ) : (
                        <>
                          <option value="Sem 1">Semester 1</option>
                          <option value="Sem 2">Semester 2</option>
                          <option value="Sem 3">Semester 3</option>
                          <option value="Sem 4">Semester 4</option>
                        </>
                      )}
                    </select>
                  ) : (
                    <input
                      type={key.includes("Date") ? "date" : "text"}
                      value={student[key]}
                      onChange={(e) => handleEdit(index, key, e.target.value)}
                      style={{ width: "90%", padding: "5px" }}
                    />
                  )}
                </td>
              ) : null
            )}

            {/* Delete Button */}
            <td>
              <IconButton color="error" onClick={() => handleDelete(index, student.studentId)}>
                <Delete />
              </IconButton>
            </td>
          </tr>
        ))}
      </tbody>


      </table>
    </div>
      </div >
    </div >
  );
};

export default MBABatch;

